import { useCallback, useEffect, useRef } from 'react';

/**
 * `useEventCallback` is a React hook for managing event callback functions that avoids an issue
 * with excessive useCallback invalidations by React
 * React issue: https://github.com/facebook/react/issues/14099
 */
export const useEventCallback = <Callback extends (...args: any[]) => any>(
  fn?: Callback | null,
): Callback => {
  const ref = useRef(fn);

  useEffect(() => {
    ref.current = fn;
  }, [fn]);

  return useCallback((...args: any[]) => ref.current && ref.current(...args), [ref]) as any;
};
